import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoginService } from '../../features/auth/login.service';

@Injectable({
  providedIn: 'root',
})
export class LotteryService {
  constructor(private http: HttpClient) {}
  baseUrl: string = environment.baseUrl;

  getAllLotteries(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/lottery/getlotteries`, payload);
  }

  createLottery(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/lottery/createlottery`, payload);
  }

  updateLottery(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/lottery/updatelottery`, payload);
  }

  deleteLottery(id: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/lottery/deletelottery`, { id });
  }
}
